import { render } from "./matches.vue?vue&type=template&id=01f27ee8&scoped=true"
import script from "./matches.vue?vue&type=script&lang=js"
export * from "./matches.vue?vue&type=script&lang=js"

import "@/css/view.css?vue&type=style&index=0&id=01f27ee8&scoped=true&lang=css"
import "@/css/information.css?vue&type=style&index=1&id=01f27ee8&scoped=true&lang=css"
import "./matches.vue?vue&type=style&index=2&id=01f27ee8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mr.Wu\\Desktop\\Files\\XiHe\\code\\xihe_levelexam_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f27ee8"]])

export default __exports__